import { render, staticRenderFns } from "./OrganizationsTable.vue?vue&type=template&id=37b96c99&scoped=true&"
import script from "./OrganizationsTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b96c99",
  null
  
)

export default component.exports